import webClient from "../config/api.config";
import { LicenceRequest } from "../types/licence.definition";

export function getAvailableLicencePlans() {
  return webClient.request({
    method: "get",
    url: "/licences/plans",
  });
}

export function getLicenceByFacility(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/licences`,
  });
}

export function createLicence(facilityId: number, data: LicenceRequest) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/licences`,
    data,
  });
}

export function pauseLicence(facilityId: number, licenceId: number) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/licences/${licenceId}/pause`,
  });
}

export function unpauseLicence(facilityId: number, licenceId: number) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/licences/${licenceId}/unpause`,
  });
}

export function getDoctorLicence(doctorId: number) {
  return webClient.request({
    method: "get",
    url: `/doctors/${doctorId}/licence`,
  });
}

export function pauseDoctorLicence(doctorId: number, licenceId: number) {
  return webClient.request({
    method: "post",
    url: `/doctors/${doctorId}/licences/${licenceId}/pause`,
  });
}

export function unpauseDoctorLicence(doctorId: number, licenceId: number) {
  return webClient.request({
    method: "post",
    url: `/doctors/${doctorId}/licences/${licenceId}/unpause`,
  });
}

export function reactivateDoctorLicence(doctorId: number, licenceId: number) {
  return webClient.request({
    method: "post",
    url: `/doctors/${doctorId}/licences/${licenceId}/reactivate`,
  });
}

export function liftDoctorLicenceCancellation(
  doctorId: number,
  licenceId: number,
  reason?: string
) {
  return webClient.request({
    method: "post",
    url: `/doctors/${doctorId}/licences/${licenceId}/lift_cancellation`,
    data: reason ? { reason } : {},
  });
}

export function getPendingDoctorLicenceRequests() {
  return webClient.request({
    method: "get",
    url: `/doctors/licence-requests`,
  });
}

export function approveDoctorLicenceRequest(requestId: number) {
  return webClient.request({
    method: "post",
    url: `/doctors/licence-requests/${requestId}/approve`,
  });
}

export function rejectDoctorLicenceRequest(requestId: number) {
  return webClient.request({
    method: "post",
    url: `/doctors/licence-requests/${requestId}/reject`,
  });
}

export function getAllDoctorLicences(params: {
  status?: string;
  plan_type?: string;
  page?: number;
  size?: number;
}) {
  return webClient.request({
    method: "get",
    url: "/doctors/licences",
    params,
  });
}

export function expireDoctorLicence(doctorId: number, licenceId: number) {
  return webClient.request({
    method: "post",
    url: `/doctors/${doctorId}/licences/${licenceId}/expire`,
  });
}

export function getAllFacilityLicences() {
  return webClient.request({
    method: "get",
    url: "/licences/facilities",
  });
}

export function getDurationDiscounts() {
  return webClient.request({
    method: "get",
    url: "/licences/duration-discounts",
  });
}
